import React from 'react';
import { Link, TableCell } from '@material-ui/core';
import { IRealEstateRatingByPartner, ServiceTypeKind } from '../../../interfaces';
import { getMoMark } from '../../../helpers';

interface IProps {
  rating: IRealEstateRatingByPartner;
  // От него зависит третья пара ячеек: Текучесть+QMPC либо SLA+Кол-во заявок
  serviceTypeKind?: ServiceTypeKind;
  // Передаются для кликабельных «Оценки МО» / NPS (месячные строки). Без них ячейка — обычный текст.
  onMoClick?: () => void;
  onNpsClick?: () => void;
}

// Прочерк вместо значения: блока в месяце не было (ноль соврал бы про нулевой балл)
const EMPTY_BLOCK = '—';

// Ячейки-значения строки рейтинга v2: общие для строки ЖК и месячных строк (DRY, выравнивание колонок).
const PartnerRatingValueCells = ({ rating, serviceTypeKind, onMoClick, onNpsClick }: IProps) => {
  const {
    relationRating,
    countPositive,
    countOvksPositive,
    countNegative,
    countOvksNegative,
    countOvks,
    actOvks,
    nps,
    npsRating,
    staffTurnover,
    qmpc,
    overdueRating,
    applicationCount,
  } = rating;

  const moMark = getMoMark(relationRating);
  // npsRating == null — ответов NPS в месяце не было
  const npsPresent = npsRating !== null && npsRating !== undefined;
  const npsText = npsPresent ? `${nps ?? 0}%` : EMPTY_BLOCK;

  return (
    <>
      <TableCell align="center">
        {onMoClick ? (
          <Link component="button" variant="body2" color="primary" onClick={onMoClick}>
            {moMark}
          </Link>
        ) : (
          moMark
        )}
      </TableCell>

      <TableCell align="center">{countPositive}</TableCell>
      <TableCell align="center">{countOvksPositive}</TableCell>
      <TableCell align="center">{countNegative}</TableCell>
      <TableCell align="center">{countOvksNegative}</TableCell>
      <TableCell align="center">{countOvks}</TableCell>
      <TableCell align="center">{actOvks}</TableCell>
      <TableCell align="center">
        {onNpsClick && npsPresent ? (
          <Link component="button" variant="body2" color="primary" onClick={onNpsClick}>
            {npsText}
          </Link>
        ) : (
          npsText
        )}
      </TableCell>

      {serviceTypeKind === 'OUTSIDE' ? (
        <>
          {/* Балл блока в номинальной шкале: 0 / 0.375 / 0.75 */}
          <TableCell align="center">{overdueRating ?? EMPTY_BLOCK}</TableCell>
          <TableCell align="center">{applicationCount ?? EMPTY_BLOCK}</TableCell>
        </>
      ) : (
        <>
          <TableCell align="center">{staffTurnover ?? 0}</TableCell>
          <TableCell align="center">{qmpc ?? 0}</TableCell>
        </>
      )}
    </>
  );
};

export default PartnerRatingValueCells;
